module.exports = __webpack_public_path__ + "static/media/grid3.2101b63f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/grid3.jpg
// module id = 881
// module chunks = 0